import moment from 'moment';

export function getDayName(index) {
	var days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
	var dayName = days[index]

	return dayName
}

export function getMonthName(index) {
	var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
	var monthName = months[index];

	return monthName;
}

/**
 * Formatea una fecha como texto en español
 * @param {string} dateStr - Fecha en formato string (YYYY-MM-DD)
 * @param {string} showYear - Controla cuándo mostrar el año:
 *                           'never' - nunca mostrar el año
 *                           'always' - siempre mostrar el año
 *                           'different' (default) - mostrar el año solo si es diferente al año actual
 * @returns {string} Fecha formateada (ej: "Lunes, 15 de Abril" o "Lunes, 15 de Abril de 2024")
 */
export function getDisplayDate(dateStr, showYear = 'different') {
	if (typeof dateStr !== 'string' || !dateStr) {
		return 'Fecha no disponible'
	}

	let date

	try {
		if (dateStr.includes('-')) {
			date = new Date(dateStr.replace(/-/g, '/'))
		} else if (dateStr.includes('/')) {
			date = new Date(dateStr)
		} else {
			date = new Date(dateStr)
		}

		if (isNaN(date.getTime())) {
			return 'Fecha inválida'
		}
	} catch (error) {
		console.error('Error al parsear fecha:', dateStr, error)
		return 'Error en fecha'
	}

	const dayName = getDayName(date.getDay())
	let day = date.getDate()
	if (day < 10) {
		day = '0' + day
	}

	const currentYear = new Date().getFullYear()
	const dateYear = date.getFullYear()

	const shouldShowYear =
		showYear === 'always' ||
		(showYear === 'different' && dateYear !== currentYear)

	if (shouldShowYear) {
		return `${dayName}, ${day} de ${getMonthName(date.getMonth())} de ${dateYear}`
	}

	return `${dayName}, ${day} de ${getMonthName(date.getMonth())}`
}

/**
 * Formatea una fecha y hora como texto en español con nombre del día
 * @param {string} dateStr - Fecha en formato string (YYYY-MM-DD)
 * @param {string} showYear - Controla cuándo mostrar el año:
 *                           'never' - nunca mostrar el año
 *                           'always' - siempre mostrar el año
 *                           'different' (default) - mostrar el año solo si es diferente al año actual
 * @returns {string} Fecha y hora formateada (ej: "Martes, 27 de Mayo, 17:35:00" o "Martes, 27 de Mayo de 2024, 17:35:00")
 */
export function getDisplayDateTime(dateStr, showYear = 'different') {
	// Validar que dateStr sea un string
	if (typeof dateStr !== 'string' || !dateStr) {
		return 'Fecha no disponible'
	}

	let date

	try {
		// Intentar diferentes formatos de fecha
		if (dateStr.includes('-')) {
			// Formato: "2025-05-26 19:51:41" o "2025-05-26"
			date = new Date(dateStr.replace(/-/g, '/'))
		} else if (dateStr.includes('/')) {
			// Formato: "2025/05/26 19:51:41" o "2025/05/26"
			date = new Date(dateStr)
		} else {
			// Intentar parsear directamente
			date = new Date(dateStr)
		}

		// Verificar si la fecha es válida
		if (isNaN(date.getTime())) {
			console.warn('Fecha inválida:', dateStr)
			return 'Fecha inválida'
		}
	} catch (error) {
		console.error('Error al parsear fecha:', dateStr, error)
		return 'Error en fecha'
	}

	const dayName = getDayName(date.getDay())
	const hours = date.getHours().toString().padStart(2, '0')
	const minutes = date.getMinutes().toString().padStart(2, '0')
	const seconds = date.getSeconds().toString().padStart(2, '0')

	let day = date.getDate()
	if (day < 10) {
		day = '0' + day
	}

	let str = `${dayName}, ${day} de ${getMonthName(date.getMonth())}, ${hours}:${minutes}:${seconds}`

	// Determinar si se debe mostrar el año
	const currentYear = new Date().getFullYear()
	const dateYear = date.getFullYear()

	const shouldShowYear =
		showYear === 'always' ||
		(showYear === 'different' && dateYear !== currentYear)

	if (shouldShowYear) {
		str = `${dayName}, ${day} de ${getMonthName(date.getMonth())} de ${dateYear}, ${hours}:${minutes}:${seconds}`
	}

	return str
}

/**
 * Formatea una fecha como texto corto en español
 * @param {string} dateStr - Fecha en formato string (YYYY-MM-DD)
 * @param {string} showYear - Controla cuándo mostrar el año:
 *                           'never' - nunca mostrar el año
 *                           'always' - siempre mostrar el año (comportamiento original)
 *                           'different' (default) - mostrar el año solo si es diferente al año actual
 * @returns {string} Fecha formateada en formato corto (ej: "15 de Abr" o "15 de Abr, 2024")
 */
export function getShortDisplayDate(dateStr, showYear = 'different') {
	const date = new Date(dateStr.split('-').join('/'))
	let day = date.getDate()

	if (day < 10) {
		day = '0' + day
	}

	const year = date.getFullYear()
	let str = `${day} de ${getMonthName(date.getMonth()).substring(0, 3)}`

	// Determinar si se debe mostrar el año
	const currentYear = new Date().getFullYear()

	const shouldShowYear =
		showYear === 'always' ||
		(showYear === 'different' && year !== currentYear)

	if (shouldShowYear) {
		str += `, ${year}`
	}

	return str
}

// Recibe un elemento del tipo Date y devuelve un string en formato 'YYYY-mm-dd'
export function getServerDate(date) {
	let day = date.getDate()

	if (day < 10) {
		day = '0' + day
	}

	const year = date.getFullYear()

	let month = date.getMonth() + 1
	if (month < 10) {
		month = '0' + month
	}

	const str = `${year}-${month}-${day}`

	return str
}

export function getMomentObject(date) {
	if (moment.isMoment(date)) {
		return date
	}

	if (date instanceof Date) {
		return moment(date)
	}

	if (typeof date === 'string') {
		return moment(date, 'YYYY-MM-DD')
	}

	// Si no es un tipo reconocido, devuelve null
	return null
}

// Convierte a string, tanto si es un moment object, como si es un date, como si es un string y los compara
export function hasEqualDateValue(date1, date2) {
	let date1Value = date1
	if (date1?._isAMomentObject) {
		date1Value = date1.format('yyyy-MM-DD')
	} else if (date1 instanceof Date) {
		date1Value = getServerDate(date1)
	}

	let date2Value = date2
	if (date2?._isAMomentObject) {
		date2Value = date2.format('yyyy-MM-DD')
	} else if (date2 instanceof Date) {
		date2Value = getServerDate(date2)
	}

	return date1Value === date2Value
}

export function getInicioAnho() {
	const hoy = new Date()
	return new Date(hoy.getFullYear(), 0, 1)
}

export function getAbbrDisplayDate(dateStr) {
	const date = new Date(dateStr.split('-').join('/'))
	let day = date.getDate()

	if (day < 10) {
		day = '0' + day
	}

	const year = date.getFullYear()

	const str = `${day}-${getMonthName(date.getMonth()).substring(0, 3).toLowerCase()}, ${year}`

	return str
}

export const getDaysDifference = (date1, date2) => {
	return Math.floor((Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) - Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())) / (1000 * 60 * 60 * 24))
}

export const addDays = (numOfDays, date = new Date()) => {
	const dateCopy = new Date(date.getTime());

	dateCopy.setDate(dateCopy.getDate() + numOfDays);

	return dateCopy;
}

export const handleChangeFecha = (e, setFn, ...extraArguments) => {
	let selected = ''
	if (e?._isAMomentObject) {
		selected = e.format('yyyy-MM-DD')
	}

	setFn(selected, ...extraArguments)
}

/**
 * Formatea solo la hora de una fecha
 * @param {string|Date} dateStr - Fecha en formato string o Date
 * @param {boolean} showSeconds - Si mostrar segundos (default: false)
 * @returns {string} Hora formateada (ej: "14:30" o "14:30:45")
 */
export function getDisplayTime(dateStr, showSeconds = false) {
	if (!dateStr) return '-'

	let date
	try {
		if (typeof dateStr === 'string') {
			if (dateStr.includes('-')) {
				date = new Date(dateStr.replace(/-/g, '/'))
			} else {
				date = new Date(dateStr)
			}
		} else {
			date = dateStr
		}

		if (isNaN(date.getTime())) {
			return '-'
		}
	} catch (error) {
		return '-'
	}

	const hours = date.getHours().toString().padStart(2, '0')
	const minutes = date.getMinutes().toString().padStart(2, '0')

	if (showSeconds) {
		const seconds = date.getSeconds().toString().padStart(2, '0')
		return `${hours}:${minutes}:${seconds}`
	}

	return `${hours}:${minutes}`
}

/**
 * Retorna una descripción relativa de la fecha (hace X días, etc.)
 * @param {string|Date} dateStr - La fecha a comparar
 * @param {string} defaultValue - Valor a mostrar si es null/undefined
 * @returns {string} Descripción relativa (ej: "Hace 3 días", "Hoy", "Ayer")
 */
export function getRelativeDate(dateStr, defaultValue = 'No disponible') {
	if (!dateStr) return defaultValue

	let date
	try {
		if (typeof dateStr === 'string') {
			if (dateStr.includes('-')) {
				date = new Date(dateStr.replace(/-/g, '/'))
			} else {
				date = new Date(dateStr)
			}
		} else {
			date = dateStr
		}

		if (isNaN(date.getTime())) {
			return defaultValue
		}
	} catch (error) {
		return defaultValue
	}

	const now = new Date()
	const diffTime = now - date
	const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

	if (diffDays === 0) {
		return 'Hoy'
	} else if (diffDays === 1) {
		return 'Ayer'
	} else if (diffDays < 7) {
		return `Hace ${diffDays} días`
	} else if (diffDays < 30) {
		const weeks = Math.floor(diffDays / 7)
		return weeks === 1 ? 'Hace 1 semana' : `Hace ${weeks} semanas`
	} else if (diffDays < 365) {
		const months = Math.floor(diffDays / 30)
		return months === 1 ? 'Hace 1 mes' : `Hace ${months} meses`
	} else {
		const years = Math.floor(diffDays / 365)
		return years === 1 ? 'Hace 1 año' : `Hace ${years} años`
	}
}

/**
 * Formatea fecha en formato numérico simple DD/MM/YYYY
 * @param {string|Date} dateStr - Fecha a formatear
 * @param {string} defaultValue - Valor por defecto si es inválida
 * @returns {string} Fecha formateada (ej: "13/12/2024")
 */
export function getNumericDate(dateStr, defaultValue = '-') {
	if (!dateStr) return defaultValue

	let date
	try {
		if (typeof dateStr === 'string') {
			if (dateStr.includes('-')) {
				date = new Date(dateStr.replace(/-/g, '/'))
			} else {
				date = new Date(dateStr)
			}
		} else {
			date = dateStr
		}

		if (isNaN(date.getTime())) {
			return defaultValue
		}
	} catch (error) {
		return defaultValue
	}

	const day = date.getDate().toString().padStart(2, '0')
	const month = (date.getMonth() + 1).toString().padStart(2, '0')
	const year = date.getFullYear()

	return `${day}/${month}/${year}`
}

/**
 * Formatea fecha y hora en formato numérico simple DD/MM/YYYY HH:mm
 * @param {string|Date} dateStr - Fecha a formatear
 * @param {string} defaultValue - Valor por defecto si es inválida
 * @returns {string} Fecha y hora formateada (ej: "13/12/2024 14:30")
 */
export function getNumericDateTime(dateStr, defaultValue = '-') {
	if (!dateStr) return defaultValue

	const datePart = getNumericDate(dateStr, null)
	if (!datePart) return defaultValue

	const timePart = getDisplayTime(dateStr)
	return `${datePart} ${timePart}`
}

/**
 * Obtiene el inicio del día (00:00:00)
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} Fecha con hora 00:00:00
 */
export function startOfDay(date = new Date()) {
	const result = new Date(date)
	result.setHours(0, 0, 0, 0)
	return result
}

/**
 * Obtiene el fin del día (23:59:59)
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} Fecha con hora 23:59:59
 */
export function endOfDay(date = new Date()) {
	const result = new Date(date)
	result.setHours(23, 59, 59, 999)
	return result
}

/**
 * Obtiene el primer día del mes
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} Primer día del mes a las 00:00:00
 */
export function startOfMonth(date = new Date()) {
	const result = new Date(date)
	result.setDate(1)
	result.setHours(0, 0, 0, 0)
	return result
}

/**
 * Obtiene el último día del mes
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} Último día del mes a las 23:59:59
 */
export function endOfMonth(date = new Date()) {
	const result = new Date(date)
	result.setMonth(result.getMonth() + 1)
	result.setDate(0)
	result.setHours(23, 59, 59, 999)
	return result
}

/**
 * Obtiene el primer día de la semana (Lunes)
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} Lunes de la semana a las 00:00:00
 */
export function startOfWeek(date = new Date()) {
	const result = new Date(date)
	const day = result.getDay()
	// Ajustar para que Lunes sea el primer día (0 = Domingo en JS)
	const diff = day === 0 ? -6 : 1 - day
	result.setDate(result.getDate() + diff)
	result.setHours(0, 0, 0, 0)
	return result
}

/**
 * Obtiene el último día de la semana (Domingo)
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} Domingo de la semana a las 23:59:59
 */
export function endOfWeek(date = new Date()) {
	const result = startOfWeek(date)
	result.setDate(result.getDate() + 6)
	result.setHours(23, 59, 59, 999)
	return result
}

/**
 * Obtiene el fin del año
 * @param {Date} date - La fecha base (default: hoy)
 * @returns {Date} 31 de diciembre a las 23:59:59
 */
export function endOfYear(date = new Date()) {
	const result = new Date(date)
	result.setMonth(11, 31)
	result.setHours(23, 59, 59, 999)
	return result
}

/**
 * Obtiene rangos de fechas predefinidos para filtros de reportes
 * @returns {Object} Objeto con rangos de fechas comunes
 */
export function getDateRanges() {
	const now = new Date()

	return {
		hoy: {
			label: 'Hoy',
			desde: startOfDay(now),
			hasta: endOfDay(now)
		},
		ayer: {
			label: 'Ayer',
			desde: startOfDay(addDays(-1, now)),
			hasta: endOfDay(addDays(-1, now))
		},
		estaSemana: {
			label: 'Esta semana',
			desde: startOfWeek(now),
			hasta: endOfWeek(now)
		},
		esteMes: {
			label: 'Este mes',
			desde: startOfMonth(now),
			hasta: endOfMonth(now)
		},
		mesAnterior: {
			label: 'Mes anterior',
			desde: startOfMonth(addDays(-30, now)),
			hasta: endOfMonth(addDays(-30, now))
		},
		esteAnho: {
			label: 'Este año',
			desde: getInicioAnho(),
			hasta: endOfYear(now)
		},
		ultimos7Dias: {
			label: 'Últimos 7 días',
			desde: startOfDay(addDays(-6, now)),
			hasta: endOfDay(now)
		},
		ultimos30Dias: {
			label: 'Últimos 30 días',
			desde: startOfDay(addDays(-29, now)),
			hasta: endOfDay(now)
		},
		ultimos90Dias: {
			label: 'Últimos 90 días',
			desde: startOfDay(addDays(-89, now)),
			hasta: endOfDay(now)
		}
	}
}